import React, { useState } from 'react';
import Justice_1 from '../../../assets/images/home_page_4/about/02.png';

const accordionItems = [
    {
        id: "collapseOne",
        heading: "01",
        title: 'Equality and solidarity',
        content: 'The generated is therefore always free from repetition, injected humour, or words etc.',
    },
    {
        id: "collapseTwo",
        heading: "02",
        title: 'To inspire humanity',
        content: 'The generated is therefore always free from repetition, injected humour, or words etc.',
    },
    {
        id: "collapseThree",
        heading: "03",
        title: 'Better living programs',
        content: 'The generated is therefore always free from repetition, injected humour, or words etc.',
    },
];

const Justice = () => {
    const [openAccordion, setOpenAccordion] = useState('collapseOne');

    const handleAccordionToggle = (id) => {
        setOpenAccordion(openAccordion === id ? null : id);
    };

    return (
        <>
            <section id="justice" className="justice-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="about-us-block">
                                <h6 className="about-sub-heading hr-lines">Why choose us</h6>
                                <h1 className="about-main-heading">Justice served with compassion</h1>
                                <div className="accordion" id="accordionExample">
                                    {accordionItems.map((item) => (
                                        <div className="accordion-item" key={item.id}>
                                            <h3 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${openAccordion === item.id ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => handleAccordionToggle(item.id)}
                                                    aria-expanded={openAccordion === item.id}
                                                    aria-controls={item.id}
                                                >
                                                    <span>{item.heading}</span>{item.title}
                                                </button>
                                            </h3>
                                            <div
                                                id={item.id}
                                                className={`accordion-collapse collapse ${openAccordion === item.id ? 'show' : ''}`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body">
                                                    {item.content}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="about-us-img">
                                <img
                                    src={Justice_1}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Justice;